import { BoardContainer } from "../board-container/BoardContainer";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { LifeBar } from "./LifeBar";
import * as Anuto from "../../../../engine/src";
import { BattleManager } from "../BattleManager";
import { AudioManager } from "../../../AudioManager";
import { BattleScene } from "../BattleScene";

export class EnemyActor extends Phaser.GameObjects.Container {

    public type: string;
    public id: number;
    public anutoEnemy: Anuto.Enemy;

    protected sprite: Phaser.GameObjects.Sprite;
    protected lifeBar: LifeBar;
    protected offX: number;
    protected offY: number;
    protected burning: boolean;

    private dead: boolean;
    private healing: boolean;
    private teleported: boolean;

    constructor(scene: Phaser.Scene, anutoEnemy: Anuto.Enemy, position: {r: number, c: number}) {

        super(scene);

        this.anutoEnemy = anutoEnemy;
        this.id = this.anutoEnemy.id;
        this.type = this.anutoEnemy.type;
        this.burning = false;
        this.dead = false;
        this.healing = false;
        this.teleported = false;

        this.sprite = this.scene.add.sprite(0, 0, "texture_atlas_4", "elemental_" + this.anutoEnemy.imageId + "_01");
        this.sprite.setOrigin(.5, 1);
        this.add(this.sprite);
       
        this.lifeBar = new LifeBar(this.scene, this.anutoEnemy.life, this.anutoEnemy.subtype);
        this.lifeBar.y = - this.sprite.height - 10;
        this.lifeBar.x -= (this.anutoEnemy.subtype.includes("boss") ? 36 : 20);
        this.lifeBar.visible = false;
        this.add(this.lifeBar);

        this.x = GameConstants.CELLS_SIZE * (position.c + .5);
        this.y = GameConstants.CELLS_SIZE * (position.r + .5);

        this.offX = GameConstants.CELLS_SIZE * (Math.random() * .15 - .075);
        this.offY = - GameConstants.CELLS_SIZE * .15 * Math.random(); 

        if (GameConstants.SHOW_DEBUG_GEOMETRY) {
            const boundingCircle = new Phaser.GameObjects.Graphics(this.scene);
            boundingCircle.lineStyle(1, 0xFF0000);
            boundingCircle.strokeCircle(0, this.anutoEnemy.deltaYBoundingRadius * GameConstants.CELLS_SIZE, this.anutoEnemy.boundingRadius * GameConstants.CELLS_SIZE);
            this.add(boundingCircle);
        }

        if (this.anutoEnemy.splitted) {

            this.scene.time.addEvent({ delay: Math.round(Math.random() * 50), callback: () => {
                this.sprite.anims.play("elemental_" + this.anutoEnemy.imageId);
            }, callbackScope: this});

            this.sprite.alpha = 0;

            const delay = GameVars.timeStepFactor === 1 ? 150 + 200 * Math.random() : 25 + 50 * Math.random();
    
            this.scene.tweens.add({
                targets: this.sprite,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: delay,
                duration: GameVars.timeStepFactor === 1 ? 750 : 150
            });
    
            this.scene.tweens.add({
                targets: this.sprite,
                y: -8,
                scaleY: 1,
                ease: Phaser.Math.Easing.Elastic.Out,
                delay: delay,
                duration: GameVars.timeStepFactor === 1 ? 1500 : 300
            });
            
        } else {

            this.sprite.alpha = 0;

            this.scene.tweens.add({
                targets: this.sprite,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: GameVars.timeStepFactor === 1 ? 750 : 150
            });

            this.sprite.anims.play("elemental_" + this.anutoEnemy.imageId);

            // para que no vayan acompasados
            const numFrames = this.sprite.anims.currentAnim.frames.length;
            const startFrame = this.sprite.anims.currentAnim.frames[Math.floor(numFrames * Math.random())];
            this.sprite.anims.setCurrentFrame(startFrame);
        }
    }

    public update(time: number, delta: number): void {

        if (this.anutoEnemy.life === 0) {
            return;
        }

        this.lifeBar.updateValue(this.anutoEnemy.life);

        if (this.anutoEnemy.teleporting) {
            // this.scaleX = .3;
            // this.scaleY = .3;
            return;
        } else if (this.scaleX === .3) {

            this.scene.tweens.add({
                targets: this,
                scaleX: 1,
                scaleY: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: GameVars.timeStepFactor === 1 ? 200 : 40
            });

            this.x = this.anutoEnemy.x * GameConstants.CELLS_SIZE + this.offX;
            this.y = this.anutoEnemy.y * GameConstants.CELLS_SIZE + this.offY;

            let teleport = this.scene.add.sprite(0, -10, "texture_atlas_3");
            this.add(teleport);

            teleport.anims.play("teleport_in");

            teleport.on("animationcomplete", () => {
                teleport.destroy();
            }, this);

            return;
        }

        if (this.anutoEnemy.type !== Anuto.GameConstants.ENEMY_WIND && (BattleManager.anutoEngine.freezeAttackActive || this.anutoEnemy.affectedByGlue)) {
            if (this.sprite.tint !== 0x5566cc) {
                this.sprite.setTint(0x5566cc);
            }
        } else {
            if (this.anutoEnemy.hasBeenTeleported) {
                if (!this.teleported) {
                    this.teleported = true;
                    this.sprite.anims.play("elemental_tint_" + this.anutoEnemy.imageId);
                }
            } else if (!this.burning && this.sprite.tint !== 0xFFFFFF) {
                this.sprite.setTint(0xFFFFFF);
            }
        }

        let smoothFactor: number;

        if (GameConstants.INTERPOLATE_TRAJECTORIES) {
            smoothFactor = GameVars.timeStepFactor === 1 ? .15 : .5;
        } else {
            smoothFactor = 1;
        }

        let prevX = this.x;

        this.x += (this.anutoEnemy.x * GameConstants.CELLS_SIZE - this.x - this.offX) * smoothFactor;
        this.y += (this.anutoEnemy.y * GameConstants.CELLS_SIZE - this.y - this.offY) * smoothFactor;

        if (prevX < this.x) {
            this.sprite.scaleX = -1;
        } else if (prevX > this.x) {
            this.sprite.scaleX = 1;
        }
        
        if (this.type === Anuto.GameConstants.ENEMY_WATER) {
            if ((this.anutoEnemy as Anuto.HealerEnemy).healing && !this.sprite.anims.currentFrame.textureFrame.toString().includes("heal")) {
                if (this.teleported) {
                    this.sprite.anims.play("elemental_tint_" + this.anutoEnemy.imageId + "_heal");
                } else {
                    this.sprite.anims.play("elemental_" + this.anutoEnemy.imageId + "_heal");
                }
                
                AudioManager.playSound("water_heals");
            } else if (!(this.anutoEnemy as Anuto.HealerEnemy).healing && this.sprite.anims.currentFrame.textureFrame.toString().includes("heal")) {
                if (this.teleported) {
                    this.sprite.anims.play("elemental_tint_" + this.anutoEnemy.imageId);
                } else {
                    this.sprite.anims.play("elemental_" + this.anutoEnemy.imageId);
                }
            }
        }

        // TUTORIAL
        if (GameVars.currentMapZone === 0 && !GameVars.gameData.specialAttacks[1]) {
            if (BattleManager.anutoEngine.round === 1 && GameVars.currentMapCount === 2 && !GameVars.gameData.specialAttacks[1]) {
                if (this.anutoEnemy.id === 0) {
                    if (this.anutoEnemy.l > 4) {
                        // mostramos el tutorial del cerdo
                        BattleManager.showSpecialAttack(1);
                    }
                }
            }
        }
    }

    public burn(): void {

        this.burning = true;
        this.sprite.setTint(0xFF8888);
    }

    public onFireAttackEnded(): void {

        this.burning = false;
        this.sprite.setTint(0xFFFFFF);
    }

    public hit(impactType: string): void {

        if (!this.dead) {
            this.lifeBar.visible = true;
        }
        
        if (impactType === GameConstants.IMPACT_FIRE && this.anutoEnemy.type !== Anuto.GameConstants.ENEMY_FIRE) {
            
            let smoke = new Phaser.GameObjects.Image(this.scene, Math.random() * this.sprite.width - this.sprite.width / 2, (Math.random() * - 30) - this.sprite.height + 20, "texture_atlas_3", "smoke_particle");
            this.add(smoke);

            smoke.alpha = 1;
            smoke.setScale(.2);

            this.scene.tweens.add({
                targets: smoke,
                y: smoke.y - 30,
                alpha: 0,
                scaleY: .75,
                scaleX: .75,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: GameVars.timeStepFactor === 1 ? 2000 : 500,
                onComplete: () => {
                    smoke.destroy();
                },
                onCompleteScope: this
            });

        } else if (impactType === GameConstants.IMPACT_ELECTRIC  && this.anutoEnemy.type !== Anuto.GameConstants.ENEMY_ELECTRIC) {

            let laser = this.scene.add.sprite(0, 0, "texture_atlas_3", "electric_damage_00");
            laser.setOrigin(.5, 1);
            laser.setScale(this.sprite.width / laser.width, this.sprite.height / laser.height);
            this.add(laser);

            laser.anims.play("electric_damage");

            laser.on("animationcomplete", () => {
                laser.destroy();
            }, this);

        } else if (impactType === GameConstants.IMPACT_MORTAR) {
            this.shake();
        } else if (impactType === GameConstants.IMPACT_MINE) {
            this.shake();
        }
    }

    public heal(): void {

        if (!this.healing) {

            this.healing = true;
            let healAnimation = this.scene.add.sprite(0, 0, "texture_atlas_3");
            healAnimation.setOrigin(.5, 1);
            healAnimation.setScale(this.sprite.width / healAnimation.width, this.sprite.height / healAnimation.height);
            healAnimation.anims.play("water_1");
            this.add(healAnimation);
    
            healAnimation.on("animationcomplete", (anim: any) => {
                if (anim.key === "water_1") {
                    healAnimation.anims.play("water_2");
                } else {
                    healAnimation.destroy();
                    this.healing = false;
                }
            }, this); 
        }
    }

    public speed(): void {

        AudioManager.playSound("wind_boost");

        let speedAnimation = this.scene.add.sprite(0, 0, "texture_atlas_3");
        speedAnimation.setOrigin(.5, 1);
        speedAnimation.setScale(2 * this.sprite.width / speedAnimation.width, 2 * this.sprite.height / speedAnimation.height);
        speedAnimation.anims.play("speed");
        this.add(speedAnimation);

        speedAnimation.on("animationcomplete", () => {
            speedAnimation.destroy();
        }, this);
    }

    public glueHit(): void {
        // de momento nada
    }

    public teleport(anutoGlueTurret: Anuto.TeleportTurret): void {

        const glueTurret_px = (anutoGlueTurret.position.c + .5) * GameConstants.CELLS_SIZE;
        const glueTurret_py = (anutoGlueTurret.position.r + .5) * (GameConstants.CELLS_SIZE - 5);

        this.scene.tweens.add({
            targets: this,
            x: glueTurret_px,
            y: glueTurret_py,
            scaleX: .3,
            scaleY: .3,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 500 : 100
        });

        AudioManager.playSound("teleport");
    }

    public die(): void {

        if (this.anutoEnemy.split) {
            AudioManager.playSound(this.type + "_divides");
        } else {
            AudioManager.playSound(this.type + "_dies");
        }

        this.dead = true;
        this.lifeBar.visible = false;

        this.scene.tweens.add({
            targets: this.sprite,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 100
        });

        let deadAnim = this.scene.add.sprite(0, -this.sprite.height / 2, "texture_atlas_4");
        this.add(deadAnim);

        deadAnim.anims.play("death_" + this.anutoEnemy.type);

        BoardContainer.currentInstance.addCoinsEnemy(this.x, this.y - this.sprite.height, this.anutoEnemy.value);

        deadAnim.on("animationcomplete", () => {
            this.destroy();
        }, this);
    }

    public isTeleporting(): boolean {

        return this.anutoEnemy.teleporting;
    }

    private shake(): void {

        // si es un boss no se sacude
        if (this.sprite.height > 100) {
            return;
        }

        let originY: number;
        let t: number;

        if (this.sprite.height < 50) {
            originY = 1.5 + .35 * Math.random();
            t = 450 + 200 * Math.random();
        } else {
            originY = 1.15;
            t = 400;
        }

        this.sprite.angle = -3;
        this.sprite.originY = originY;

        this.scene.tweens.add({
            targets: this.sprite,
            originY: 1,
            angle: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: t
        });
    }
}
